import React from 'react';
import { withLocalize } from 'react-localize-redux';
import DynamoDBEndUsers from '../../../../aws/dynamodb/endusers';
import DynamoDBAdministrators from '../../../../aws/dynamodb/administrators';
import DynamoDBClients from '../../../../aws/dynamodb/clients';
import DDBTransactions from '../../../../aws/dynamodb/ddb-transactions';
import DynamoDBMeterValues from '../../../../aws/dynamodb/meter-values';
import DynamoDBRFIDs from '../../../../aws/dynamodb/rfids';
import DynamoDBTransactionsRunning from '../../../../aws/dynamodb/transactions-running';
import Lambda from '../../../../aws/lambda';
import { asyncTimeout } from '../../../../utilities';
import RunningTransactions from './presentation';
import { getStopIdTag } from './rfid';

class RunningTransactionsContainer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      processing: false,
      filters: {
        chargebox: null,
      },
      runningTransactions: [],
      users: {},
      rfids: {},
      chargeboxes: {},
      menuAnchorEl: null,
      selectedTransaction: null,
      dialogStopOpen: false,
      dialogUnlockOpen: false,
      dialogTrendOpen: false,
      dialogForceStopOpen: false,
      forceStopMode: 'stop',
      forceStopPayload: null,
      forceStopPayloadError: false,
      deletePlan: null,
      deletePlanError: false,
    };
    this.onChange = this.onChange.bind(this);
    this.search = this.search.bind(this);
    this.openCloseMenu = this.openCloseMenu.bind(this);
    this.toggleStopDialog = this.toggleStopDialog.bind(this);
    this.toggleUnlockDialog = this.toggleUnlockDialog.bind(this);
    this.waitForStop = this.waitForStop.bind(this);
    this.stop = this.stop.bind(this);
    this.toggleForceStopDialog = this.toggleForceStopDialog.bind(this);
    this.forceStop = this.forceStop.bind(this);
    this.changeForceStopMode = this.changeForceStopMode.bind(this);
    this.unlock = this.unlock.bind(this);
    this.secureSetState = this.secureSetState.bind(this);
    this.toggleDialogTrend = this.toggleDialogTrend.bind(this);
    this._isMounted = false;
  }

  get isMounted() {
    return this._isMounted;
  }

  set isMounted(val) {
    this._isMounted = val;
  }

  secureSetState(state, callback) {
    if (!this.isMounted) {
      return;
    }
    this.setState(state, callback);
  }

  openCloseMenu(transaction) {
    return (event) => {
      if (transaction === null) {
        this.secureSetState({ menuAnchorEl: null, selectedTransaction: null });
      } else {
        this.secureSetState({ menuAnchorEl: event.currentTarget, selectedTransaction: { ...transaction } });
      }
    };
  }

  toggleStopDialog() {
    this.secureSetState({ menuAnchorEl: null, dialogStopOpen: !this.state.dialogStopOpen });
  }

  toggleUnlockDialog() {
    this.secureSetState({ menuAnchorEl: null, dialogUnlockOpen: !this.state.dialogUnlockOpen });
  }

  onChange(e) {
    if (this.state.processing) {
      return;
    }
    let { name, value } = e.target;
    let filters = JSON.parse(JSON.stringify(this.state.filters));
    filters[name] = value;
    this.secureSetState({ filters });
  }

  async waitForStop(chargebox, connector, transactionId) {
    for (let i = 0; i < 30; i++) {
      let data = await DynamoDBTransactionsRunning.getByChargebox(chargebox, true);
      if (data.Items && data.Items.findIndex((t) => t.chargebox === chargebox && t.connector === connector && t.transaction_id === transactionId) === -1) {
        return;
      }
      await asyncTimeout(1000);
    }
    throw 'not_stopped';
  }

  stop(confirm) {
    if (!confirm) {
      this.toggleStopDialog();
      return;
    }
    this.secureSetState({ processing: true }, async () => {
      let functionName = '';
      if (
        this.state.chargeboxes[this.state.selectedTransaction.chargebox].type.msg === 'soap' &&
        this.state.chargeboxes[this.state.selectedTransaction.chargebox].type.version === '1.5'
      ) {
        functionName = 'OcppSoap15RemoteStopTransaction';
      } else if (
        this.state.chargeboxes[this.state.selectedTransaction.chargebox].type.msg === 'json' &&
        this.state.chargeboxes[this.state.selectedTransaction.chargebox].type.version === '1.6'
      ) {
        functionName = 'OcppJson16RemoteStopTransaction';
      } else {
        this.secureSetState({ processing: false, dialogStopOpen: !this.state.dialogStopOpen, selectedTransaction: null });
      }
      try {
        let data = await Lambda.invoke(functionName, {
          admin: this.props.user.id,
          transaction: {
            chargebox: this.state.selectedTransaction.chargebox,
            connector: this.state.selectedTransaction.connector,
            id: this.state.selectedTransaction.transactionId,
          },
        });
        if (data === null && functionName === 'OcppJson16RemoteStopTransaction') {
          await this.waitForStop(
            this.state.selectedTransaction.chargebox,
            this.state.selectedTransaction.connector,
            this.state.selectedTransaction.transactionId
          );
        }

        let runningTransactions = this.state.runningTransactions.filter(
          (tr) =>
            tr.chargebox !== this.state.selectedTransaction.chargebox ||
            tr.connector !== this.state.selectedTransaction.connector ||
            tr.transactionId !== this.state.selectedTransaction.transactionId
        );

        this.props.showHideSnackbar('stopSuccess');
        this.secureSetState({ processing: false, dialogStopOpen: !this.state.dialogStopOpen, selectedTransaction: null, runningTransactions });
      } catch (err) {
        console.log(err);
        this.props.showHideSnackbar('stopError');
        this.secureSetState({ processing: false, dialogStopOpen: !this.state.dialogStopOpen });
      }
    });
  }

  async getForceStopPayload(transaction) {
    // Ultimo meter value della transazione salvato su chargeboxes_meter_values (energia attiva importata)
    let lastMeter = await DynamoDBMeterValues.getLast(transaction.chargebox, transaction.connector, transaction.transactionId);
    let meterStop = transaction.meterStart;
    let lastTimestamp = transaction.dateStarted;
    if (lastMeter) {
      meterStop = lastMeter.uom.toLowerCase() === 'kwh' ? lastMeter.value * 1000 : lastMeter.value;
      lastTimestamp = lastMeter.timestamp;
    }
    // Un minuto dopo l'ultimo meter value (o dall'inizio della transazione se non ce ne sono)
    lastTimestamp += 60000;
    return {
      chargebox: transaction.chargebox,
      body: {
        meterStop,
        transactionId: transaction.transactionId,
        timestamp: new Date(lastTimestamp).toISOString().replace(/\.\d{3}Z$/, 'Z'),
        idTag: getStopIdTag(transaction, this.state.chargeboxes[transaction.chargebox].vendor),
        reason: 'Remote',
      },
    };
  }

  // Calcola quanto budget va sbloccato sull'RFID se la transazione viene eliminata senza passare dalla StopTransaction.
  // Stesse condizioni di validateRFID (StartTransaction) per capire se il budget era stato bloccato,
  // stesso importo usato da StopTransaction per sbloccarlo (payment.preAuth o payment_limit del cliente).
  async getDeletePlan(transaction) {
    let lastMeter = await DynamoDBMeterValues.getLast(transaction.chargebox, transaction.connector, transaction.transactionId);
    let plan = { hasMeters: lastMeter !== null, rfid: null, amount: 0, oldLocked: null, newLocked: null };
    let rfidId = `${transaction.client}__${transaction.idTag}`;
    let rfidData = await DynamoDBRFIDs.get(rfidId);
    let rfid = rfidData && rfidData.Item;
    if (!rfid) {
      return plan;
    }
    plan.rfid = rfidId;
    let clientData = await DynamoDBClients.get(transaction.client);
    let client = clientData.Item;
    let chargebox = this.state.chargeboxes[transaction.chargebox];
    let customPayment =
      rfid.custom_payment && (!rfid.custom_payment.chargeboxes || rfid.custom_payment.chargeboxes.includes(transaction.chargebox))
        ? rfid.custom_payment
        : chargebox.custom_payment || null;
    let rfidEndpoint = client.rest_api && client.rest_api.enabled && client.rest_api.endpoints ? client.rest_api.endpoints.rfid : null;
    let vehiclePayment = client.payment_type ? client.payment_type[chargebox.type.vehicle] : null;

    let locked =
      !(rfidEndpoint && rfidEndpoint.doublecheck === 'false') &&
      !(customPayment && customPayment.type === 'free') &&
      rfid.budget !== null &&
      rfid.budget !== undefined &&
      !(rfid.infiniteOn && rfid.infiniteOn.enabled && rfid.infiniteOn.chargeboxes.includes(transaction.chargebox)) &&
      !(!customPayment && vehiclePayment && vehiclePayment.type === 'free');
    if (!locked) {
      return plan;
    }
    plan.amount = (transaction.payment && transaction.payment.preAuth) || client.payment_limit.amount;
    plan.oldLocked = rfid.budget.locked || 0;
    plan.newLocked = Math.max(0, Math.round((plan.oldLocked - plan.amount) * 100) / 100);
    return plan;
  }

  toggleForceStopDialog() {
    if (this.state.dialogForceStopOpen) {
      this.secureSetState({ dialogForceStopOpen: false, forceStopPayload: null, deletePlan: null });
      return;
    }
    let transaction = this.state.selectedTransaction;
    this.secureSetState(
      {
        menuAnchorEl: null,
        dialogForceStopOpen: true,
        forceStopMode: 'stop',
        forceStopPayload: null,
        forceStopPayloadError: false,
        deletePlan: null,
        deletePlanError: false,
      },
      async () => {
        try {
          let forceStopPayload = await this.getForceStopPayload(transaction);
          this.secureSetState({ forceStopPayload });
        } catch (err) {
          // Senza idTag ricostruibile o meter value leggibile resta disponibile solo l'eliminazione
          console.log(err);
          this.secureSetState({ forceStopPayloadError: true, forceStopMode: 'delete' });
        }
        try {
          let deletePlan = await this.getDeletePlan(transaction);
          this.secureSetState({ deletePlan });
        } catch (err) {
          console.log(err);
          this.secureSetState({ deletePlanError: true });
        }
      }
    );
  }

  changeForceStopMode(e) {
    this.secureSetState({ forceStopMode: e.target.value });
  }

  forceStop(confirm) {
    if (!confirm) {
      this.toggleForceStopDialog();
      return;
    }
    this.secureSetState({ processing: true }, async () => {
      let { selectedTransaction, forceStopPayload, forceStopMode, deletePlan } = this.state;
      try {
        if (forceStopMode === 'delete') {
          // Eliminazione e sblocco budget nella stessa transazione DynamoDB: o avvengono entrambi o nessuno dei due
          let items = [DynamoDBTransactionsRunning.removeTransact(selectedTransaction.chargebox, selectedTransaction.connector, selectedTransaction.transactionId)];
          if (deletePlan.amount > 0) {
            items.push(DynamoDBRFIDs.setLockedBudgetTransact(deletePlan.rfid, deletePlan.oldLocked, deletePlan.newLocked));
          }
          await DDBTransactions.transactWrite(items);
        } else {
          // Lambda.invoke non rilancia gli errori: un esito diverso da Accepted vale come fallimento
          let data = await Lambda.invoke('OcppJson16StopTransaction', forceStopPayload);
          if (!data || !data.idTagInfo || data.idTagInfo.status !== 'Accepted') {
            throw data;
          }
        }
        let runningTransactions = this.state.runningTransactions.filter(
          (tr) =>
            tr.chargebox !== selectedTransaction.chargebox ||
            tr.connector !== selectedTransaction.connector ||
            tr.transactionId !== selectedTransaction.transactionId
        );
        this.props.showHideSnackbar(forceStopMode === 'delete' ? 'deleteSuccess' : 'stopSuccess');
        this.secureSetState({ processing: false, dialogForceStopOpen: false, forceStopPayload: null, deletePlan: null, selectedTransaction: null, runningTransactions });
      } catch (err) {
        console.log(err);
        this.props.showHideSnackbar(forceStopMode === 'delete' ? 'deleteError' : 'forceStopError');
        this.secureSetState({ processing: false, dialogForceStopOpen: false, forceStopPayload: null, deletePlan: null });
      }
    });
  }

  unlock(confirm) {
    if (!confirm) {
      this.toggleUnlockDialog();
      return;
    }
    this.secureSetState({ processing: true }, async () => {
      let functionName = '';
      if (
        this.state.chargeboxes[this.state.selectedTransaction.chargebox].type.msg === 'soap' &&
        this.state.chargeboxes[this.state.selectedTransaction.chargebox].type.version === '1.5'
      ) {
        functionName = 'OcppSoap15UnlockConnector';
      } else if (
        this.state.chargeboxes[this.state.selectedTransaction.chargebox].type.msg === 'json' &&
        this.state.chargeboxes[this.state.selectedTransaction.chargebox].type.version === '1.6'
      ) {
        functionName = 'OcppJson16UnlockConnector';
      } else {
        this.secureSetState({ processing: false, dialogUnlockOpen: !this.state.dialogUnlockOpen, selectedTransaction: null });
      }
      try {
        let data = await Lambda.invoke(functionName, {
          chargebox: this.state.selectedTransaction.chargebox,
          user: this.props.user.id,
          connector: this.state.selectedTransaction.connector,
        });
        if (data === null && functionName === 'OcppJson16UnlockConnector') {
          await this.waitForStop(
            this.state.selectedTransaction.chargebox,
            this.state.selectedTransaction.connector,
            this.state.selectedTransaction.transactionId
          );
        }

        let runningTransactions = this.state.runningTransactions.filter(
          (tr) =>
            tr.chargebox !== this.state.selectedTransaction.chargebox ||
            tr.connector !== this.state.selectedTransaction.connector ||
            tr.transactionId !== this.state.selectedTransaction.transactionId
        );

        this.props.showHideSnackbar('unlockSuccess');
        this.secureSetState({ processing: false, dialogUnlockOpen: !this.state.dialogUnlockOpen, selectedTransaction: null, runningTransactions });
      } catch (err) {
        console.log(err);
        this.props.showHideSnackbar('unlockError');
        this.secureSetState({ processing: false });
      }
    });
  }

  search() {
    if (this.state.processing) {
      return;
    }
    this.secureSetState({ processing: true, runningTransactions: [] }, async () => {
      let chargeboxes = this.props.chargeboxes.reduce((acc, c) => {
        acc[c.id] = { alias: c.alias, type: c.type, vendor: c.vendor, custom_payment: c.custom_payment };
        return acc;
      }, {});
      try {
        let data = null;
        if (this.state.filters.chargebox.id === '*') {
          if (this.props.user.type === 'client') {
            data = await DynamoDBTransactionsRunning.getByClient(this.props.user.client, true);
          } else {
            data = await DynamoDBTransactionsRunning.getAll(true);
          }
        } else {
          data = await DynamoDBTransactionsRunning.getByChargebox(this.state.filters.chargebox.id, true);
        }
        console.log(data);
        if (data.Count === 0) {
          this.secureSetState({ processing: false, chargeboxes });
          this.props.showHideSnackbar('runningNotFound');
          return;
        }
        let runningTransactions = [];
        let usersToGet = [];
        let adminsToGet = [];
        let rfidsToGet = [];
        for (let item of data.Items) {
          let lastMeterValue = await DynamoDBMeterValues.getLast(item.chargebox, item.connector, item.transaction_id);
          let runningTransaction = {
            meters: item.meters,
            chargebox: item.chargebox,
            client: item.client,
            type: item.type,
            connector: item.connector,
            meterStart: item.meter_start,
            transactionId: item.transaction_id,
            payment: item.hasOwnProperty('payment') ? item.payment : null,
            dateStarted: item.timestamp,
            lastMeterValue: '0 Wh',
            user: item.user,
            idTag: item.id_tag,
          };
          if (lastMeterValue) {
            let value = 0;
            if (lastMeterValue.uom.toLowerCase() === 'wh') {
              value = Math.round(lastMeterValue.value - item.meter_start);
            } else {
              value = Math.round((lastMeterValue.value - item.meter_start / 1000) * 1000) / 1000;
            }

            if (lastMeterValue.uom.toLowerCase() === 'wh' && value > 1000) {
              runningTransaction.lastMeterValue = `${Math.round(value) / 1000} kWh`;
            } else {
              runningTransaction.lastMeterValue = `${value} ${lastMeterValue.uom}`;
            }
          }
          runningTransactions.push(runningTransaction);
          if (item.type === 'local' && rfidsToGet.indexOf(item.id_tag) === -1 && !this.state.rfids.hasOwnProperty(item.id_tag)) {
            rfidsToGet.push(`${item.client}__${item.id_tag}`);
          } else if (item.type === 'remote' && usersToGet.indexOf(item.user) === -1 && !this.state.users.hasOwnProperty(item.user)) {
            if (item.payment && item.payment.method && item.payment.method === 'free') {
              if (adminsToGet.indexOf(item.user) === -1 && !this.state.users.hasOwnProperty(item.user)) {
                adminsToGet.push(item.user);
              }
            } else {
              usersToGet.push(item.user);
            }
          }
        }

        let users = JSON.parse(JSON.stringify(this.state.users));
        let rfids = JSON.parse(JSON.stringify(this.state.rfids));
        for (let i = 0; i < Math.ceil(rfidsToGet.length / 25); i++) {
          let ddbRFIDs = await DynamoDBRFIDs.batchGet(rfidsToGet.slice(i * 25, (i + 1) * 25), null);
          for (let rfid of ddbRFIDs) {
            let { id, alias, user } = rfid;
            rfids[id.split('__')[1]] = { alias, user };
            if (typeof user === 'string' && user.length > 0 && usersToGet.indexOf(user) === -1) {
              usersToGet.push(user);
            }
          }
        }
        for (let i = 0; i < Math.ceil(usersToGet.length / 25); i++) {
          let ddbUsers = await DynamoDBEndUsers.batchGet(usersToGet.slice(i * 25, (i + 1) * 25));
          for (let user of ddbUsers) {
            let { id, ...u } = user;
            users[id] = u;
          }
        }

        for (let i = 0; i < Math.ceil(adminsToGet.length / 25); i++) {
          let ddbAdmins = await DynamoDBAdministrators.batchGet(adminsToGet.slice(i * 25, (i + 1) * 25));
          for (let admin of ddbAdmins) {
            let { id, ...u } = admin;
            u.admin = true;
            users[id] = u;
          }
        }

        this.secureSetState({ processing: false, chargeboxes, runningTransactions, users, rfids });
      } catch (err) {
        console.log(err);
        this.secureSetState({ processing: false, chargeboxes });
        this.props.showHideSnackbar('runningFetchError');
      }
    });
  }

  toggleDialogTrend() {
    this.secureSetState({ dialogTrendOpen: !this.state.dialogTrendOpen, menuAnchorEl: null });
  }

  componentDidMount() {
    this.isMounted = true;
  }

  componentWillUnmount() {
    this.isMounted = false;
  }

  render() {
    let chargeboxesList = this.props.chargeboxes.slice();
    chargeboxesList.splice(0, 0, { id: '*', alias: this.props.translate('transactions.all') });
    return (
      <RunningTransactions
        {...this.state}
        user={this.props.user}
        chargeboxesList={chargeboxesList}
        openCloseMenu={this.openCloseMenu}
        onChange={this.onChange}
        search={this.search}
        toggleStopDialog={this.toggleStopDialog}
        toggleUnlockDialog={this.toggleUnlockDialog}
        stop={this.stop}
        toggleForceStopDialog={this.toggleForceStopDialog}
        forceStop={this.forceStop}
        changeForceStopMode={this.changeForceStopMode}
        unlock={this.unlock}
        toggleDialogTrend={this.toggleDialogTrend}
      />
    );
  }
}

export default withLocalize(RunningTransactionsContainer);
